module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "items": _vm.organizations,
      "item-text": "name",
      "item-value": "id",
      "label": _vm.$t('OrganizationFilter.organizationFilter'),
      "return-object": "",
      "solo": _vm.solo,
      "outlined": _vm.outlined,
      "menu-props": _vm.outlined ? {
        bottom: true,
        offsetY: true
      } : {},
      "hide-details": ""
    },
    on: {
      "change": _vm.updateSelectedOrganization
    },
    model: {
      value: (_vm.auxSelectedOrganization),
      callback: function($$v) {
        _vm.auxSelectedOrganization = $$v
      },
      expression: "auxSelectedOrganization"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-652c0287","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/OrganizationFilter.vue
// module id = 1721
// module chunks = 0